import { take, put, call, fork } from 'redux-saga/effects';
import { browserHistory } from 'react-router';

import * as api from '../services/api';
import * as environmentActions from '../actions/environment';
import * as navigate from '../services/navigate';
import { fetchEntities, watchPollEntities } from './entities';
import { checkForErrors, handleError } from './common';

import {
    SET_LOGGED_IN,
    LOGOUT,
    FETCH_INITIAL_DATA,
    RECEIVED_ENTITIES,
} from '../constants';

function* watchSetLoggedIn() {
    while(true) {
        const { loggedIn } = yield take(SET_LOGGED_IN);
        window.localStorage.setItem(`loggedIn`, loggedIn);
    }
}

function* watchLogout() {
    yield take(LOGOUT);
    yield put(environmentActions.setLoggedIn(false));
    navigate.toLogOut();
}

function* initialDataFetch() {
    yield take(FETCH_INITIAL_DATA);

    // As this is the initial fetch we should show the app loading screen
    const loadingRoute = `/loading`;
    if (window.location.href.substr(-loadingRoute.length) !== loadingRoute)
        browserHistory.push(loadingRoute);

    const authedUserResponse = yield call(api.fetchAuthedUser);
    let priorityError = checkForErrors([authedUserResponse]);

    if (priorityError) {
        yield call(handleError, priorityError);
        return;
    }

    navigate.loginSucceeded();

    const personSettingsResponse = yield call(api.fetchPersonSettings, authedUserResponse.body.personId);
    priorityError = checkForErrors([personSettingsResponse]);

    if (priorityError) {
        yield call(handleError, priorityError);
    } else if (personSettingsResponse) {
        yield put(environmentActions.receivedAuthedUser(authedUserResponse.body));
        yield put(environmentActions.receivedPerson(personSettingsResponse.body));

        if (process.env.FAKE_API)
            yield fork(fetchEntities);
        else
            yield fork(watchPollEntities);

        // Wait for our initial received entities and redirect to the /bookings route
        yield take(RECEIVED_ENTITIES);
        browserHistory.replace(`/bookings`);
    }
}

export {
    initialDataFetch,
    watchSetLoggedIn,
    watchLogout,
};



// WEBPACK FOOTER //
// ./scripts/sagas/environment.js